import { useEffect, useState } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import type { MesaVista } from '@shared/types';
import { MesasGrid } from '@renderer/components/mesas/MesasGrid';

interface Props {
  onSiguiente: (mesaId: number) => void;
  onAtras: () => void;
  /** Permite continuar sin mesa (para llevar / pickup en mostrador) */
  permitirSinMesa?: boolean;
}

/**
 * Sprint 9.0: usa `<MesasGrid mode="select" />`. El estado de cada mesa
 * viene calculado desde el backend (single source of truth), por lo que
 * ya no puede divergir respecto a `MesasPage` o el Dashboard.
 */
export function MesaSelector({ onSiguiente, onAtras, permitirSinMesa = false }: Props) {
  const [mesas, setMesas] = useState<MesaVista[]>([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    (async () => {
      const res = await window.api.mesas.listar();
      if (res.ok) setMesas(res.data);
      setCargando(false);
    })();
  }, []);

  const disponibles = mesas.filter((m) => m.estado === 'disponible').length;
  const ocupadas = mesas.length - disponibles;

  return (
    <div className="flex h-full flex-col">
      <div className="flex items-center gap-3 border-b border-slate-200 px-6 py-3 bg-white">
        <button onClick={onAtras} className="btn-ghost p-2" aria-label="Atrás">
          <ArrowLeft className="h-4 w-4" />
        </button>
        <div>
          <h2 className="text-lg font-semibold">Selecciona la mesa</h2>
          <p className="text-xs text-slate-500">
            {disponibles} disponibles · {ocupadas} ocupadas
          </p>
        </div>
      </div>

      <div className="flex-1 overflow-auto p-6">
        {cargando ? (
          <div className="text-center text-slate-400 py-12">Cargando...</div>
        ) : (
          <div className="space-y-6">
            <MesasGrid mesas={mesas} mode="select" onMesaLibre={onSiguiente} />

            {permitirSinMesa && (
              <button onClick={() => onSiguiente(0)} className="btn-secondary mx-auto block">
                Continuar sin mesa
                <ArrowRight className="h-4 w-4 ml-1" />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
